import { render } from "./GalaxyMap.vue?vue&type=template&id=4c646f0c&scoped=true"
import script from "./GalaxyMap.vue?vue&type=script&lang=js"
export * from "./GalaxyMap.vue?vue&type=script&lang=js"

import "./GalaxyMap.vue?vue&type=style&index=0&id=4c646f0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c646f0c"]])

export default __exports__